


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IRegularizationReviewModel, IRegularizationReviewDetailModel } from '@/models/AttendanceModels';
import API from '@/Api';
import { triggerAsyncId } from 'async_hooks';
import { constants } from 'http2';
const namespace: string = 'AppStore';
@Component
export default class AttendanceReview extends Vue {
        @Prop() public type!: any;
        public headers: any[] = [
            {
            text: 'Employee Id',
            align: 'left',
            sortable: false,
            value: 'empId',
            },
            {
            text: 'Employee Name',
            align: 'left',
            sortable: false,
            value: 'empName',
            },
            {
            text: 'Designation',
            align: 'left',
            sortable: false,
            value: 'designation',
            },
            {
            text: 'Request(s)',
            align: 'left',
            sortable: false,
            value: 'leaves',
            },
            {
            text: 'Actions',
            align: 'left',
            sortable: false,
            value: 'actions',
            },
        ];
//          public subHeaders: any[] = [
//             {
//             text: '',
//             align: 'left',
//             sortable: false,
//             value: 'select',
//             },
//             {
//             text: 'Date',
//             align: 'left',
//             sortable: false,
//             value: 'date',
//             },
//             {
//             text: 'Leave Type',
//             align: 'left',
//             sortable: false,
//             value: 'leaveType',
//             },
//             {
//             text: 'In Time',
//             align: 'left',
//             sortable: false,
//             value: 'inTime',
//             },
//             {
//             text: 'Out Time',
//             align: 'left',
//             sortable: false,
//             value: 'outTime',
//             },
//             { 
//                 text: 'OD From Time',
//                  align: 'left',
//                   sortable: false,
//                    value: 'ODInTime'
//                  },
//   { 
//     text: 'OD To Time', 
//     align: 'left', 
//     sortable: false, 
//     value: 'ODOutTime' 
// },
//             {
//             text: 'Total Hours',
//             align: 'left',
//             sortable: false,
//             value: 'totalHours',
//             },
//             {
//             text: 'Comment',
//             align: 'left',
//             sortable: false,
//             value: 'comment',
//             },
//             {
//   text: 'Attendance In',
//   align: 'left',
//   sortable: false,
//   value: 'attendanceInTime',
// },
// {
//   text: 'Attendance Out',
//   align: 'left',
//   sortable: false,
//   value: 'attendanceOutTime',
// },
//         ];
public subHeaders: any[] = [
  { text: '', align: 'left', sortable: false, value: 'select' },
  { text: 'Date', align: 'left', sortable: false, value: 'date' },
  { text: 'Leave Type', align: 'left', sortable: false, value: 'regularizationType' },
  { text: 'In Time', align: 'left', sortable: false, value: 'inTime' },
  { text: 'Out Time', align: 'left', sortable: false, value: 'outTime' },
  { text: 'OD From Time', align: 'left', sortable: false, value: 'attendanceInTime' },
  { text: 'OD To Time', align: 'left', sortable: false, value: 'attendanceOutTime' },
  { text: 'Total Hours', align: 'left', sortable: false, value: 'totalHours' },
  { text: 'Comment', align: 'left', sortable: false, value: 'comment' },
];
public title: string = 'Leave Review';
        public dialog: boolean = false;
        public items: IRegularizationReviewModel[] = [];
        public selectedItem: IRegularizationReviewModel = {} as any;
        // public subHeaderRow: IRegularizationReviewDetailModel[] = [{

        //     id: 0,
        //     date: 'Date',
        //     regularizationType: 'Regularization Type',
        //     selected: false,
        //     comment: 'Comment',
        //     inTime: 'In Time',
        //     outTime: 'Out Time',
        //     ODInTime: 'OD In Time',
        //     ODOutTime: 'OD Out Time',
        //     totalHours: 'Total Hours',
        //     attendanceInTime: '',      
        //                 attendanceOutTime: '',    
        // }];
        public subHeaderRow: IRegularizationReviewDetailModel[] = [{
  id: 0,
  date: 'Date',
  regularizationType: 'Regularization Type',
  selected: false,
  comment: 'Comment',
  inTime: 'In Time',
  outTime: 'Out Time',
  attendanceInTime: 'OD In Time',     
  attendanceOutTime: 'OD Out Time',   
  
  totalHours: 'Total Hours',

 
}];

        get pageTitel() {
           return this.type === '0' ? 'Regularization Review' : 'Leave Review';
        }

        get reviewDetails() {
            this.subHeaderRow[0].selected = false;
            return this.selectedItem.reviewDetails
                ? this.subHeaderRow.concat(this.selectedItem.reviewDetails)
                : [] as any;
        }

        public load() {
            const url = this.type === '0' ? '/api/regularization-review' : '/api/leave-review';
            API.Instance
                        .get(url)
                        .then((response) => {
                            this.items = response.data;
                        });
        }
        public mounted() {
           this.load();
        }

        public select(item: IRegularizationReviewModel) {
            this.selectedItem = item;
            this.dialog = true;
        }

        public OnCheckBoxClick(item: IRegularizationReviewDetailModel) {
            if (item.id === 0) {
                this.selectedItem.reviewDetails.forEach((element) => {
                    element.selected = item.selected;
                });
            }
        }

        public getSelectedIds(): number[] {
            return this.selectedItem.reviewDetails.filter((x, y, z) => x.selected === true).map((x) => x.id);
        }

        public approve() {
            const ids = this.getSelectedIds();

            if (ids.length === 0) {
                this.$store.commit('AppStore/SNACK_BAR',
                    {text: 'Kindly select checkbox', show: true});
                return;
            }

            window.dialog.open('Confirmation', 'Are you sure?').then((dialogResult: any) => {
                    if (dialogResult === true) {
                        API.Instance
                        .post('/api/regularization-review', {status: 1, ids})
                        .then((response) => {
                            this.load();
                            this.dialog = false;
                        });
                    }
            });
        }

        public decline() {
            const ids = this.getSelectedIds();

            if (ids.length === 0) {
            this.$store.commit('AppStore/SNACK_BAR',
                {text: 'Kindly select checkbox', show: true});
            return;
            }

            window.dialog.open('Confirmation', 'Are you sure?').then((dialogResult: any) => {
                if (dialogResult === true) {
                    API.Instance
                            .post('/api/regularization-review', {status: 2, ids})
                            .then((response) => {
                                this.load();
                                this.dialog = false;
                            });
                }
            });

        }
}
